var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0009 27.9996C17.2695 27.9996 12 27.9996 12 24.6504C12 21.6645 15.9959 21.3193 19.0009 21.3193C20.7324 21.3193 26.0001 21.3193 26.0001 24.6685C26.0001 27.6545 22.0051 27.9996 19.0009 27.9996",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0013 22.6848C15.2353 22.6848 13.3262 23.348 13.3262 24.657C13.3262 25.9779 15.2353 26.6474 19.0013 26.6474C22.7665 26.6474 24.6747 25.9842 24.6747 24.6752C24.6747 23.3543 22.7665 22.6848 19.0013 22.6848M19.0013 19.62H18.973C16.3904 19.6118 14.2983 17.453 14.3072 14.8077C14.3072 12.1579 16.4125 10 19.0013 10C21.5891 10 23.6936 12.1579 23.6936 14.8105C23.6936 17.463 21.5891 19.62 19.0013 19.62",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0021 11.2935C17.1097 11.2935 15.5701 12.8707 15.5701 14.8103C15.5639 16.7435 17.0921 18.3198 18.9764 18.327L19.0021 18.9739V18.327C20.8935 18.327 22.4323 16.7489 22.4323 14.8103C22.4323 12.8707 20.8935 11.2935 19.0021 11.2935",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSelect);
export default __webpack_public_path__ + "static/media/profile-select.06a78606aa8dc3dcffcbe4ebe6a95c15.svg";
export { ForwardRef as ReactComponent };